import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import ReactGA from 'react-ga4';

const PageTracking = () => {
  const location = useLocation();

  useEffect(() => {
    //console.log('Tracking pageview for:', location.pathname);
    ReactGA.gtag('config', 'G-X919BG47PW', {
      page_path: location.pathname,
    });
  }, [location]);

  return null; // this component doesn't render anything visible
};

export default PageTracking;
